<template>
  <nav-bar :menuItems="menuItems" :portalButton="true" />
</template>
<script>
export default {
	name: "NavigationBarAuditOnsite",
	data: () => ({
		menuItems: [
			{ title: "Initiator Dashboard", link: "/auditonsite/onsitedashboard" },
			{ title: "Initiator view", link: "/auditonsite/onsitesender" },
			{ title: "Onsite-Auditor view", link: "/auditonsite/onsiteauditor" },
			{ title: "Supplier view", link: "/auditonsite/onsitesupplier" },
			{ title: "Templates", link: "/auditonsite/onsitetemplates" },
		],
		sidebar: false
	})
}
</script>
